import config from "config";
import esriId from "@arcgis/core/identity/IdentityManager";
import ServerInfo from "@arcgis/core/identity/ServerInfo";

class GetArcGISToken {
  tokenRegistered = false;
  token = null;
  user = undefined;

  static waitForArcgisToken() {
    return GetArcGISToken.queryForToke();
  }

  static retriveArcgisToken(token) {
    return GetArcGISToken.queryForAOIToken(token);
  }

  static queryForAOIToken(token) {
    return new Promise((resolve, reject) => {
      // if (GetArcGISToken.tokenRegistered) {
      //   resolve();
      //   return;
      // }

      // try {
      //   GetArcGISToken.user = JSON.parse(sessionStorage.getItem("user")) || {
      //     displayName: "Guest",
      //   };
      //   if (
      //     Date.now() - (GetArcGISToken.user.timestamp || 0) >
      //     1000 * 60 * 60 * config.sessionTimeout
      //   )
      //     throw new Error();
      // } catch {
      //   var err = new Error();
      //   err.cause = { httpCode: 403 };
      //   throw err;
      // }

      let serverInfo = new ServerInfo();
      serverInfo.server = config.portalUrl;
      serverInfo.tokenServiceUrl = config.webSrvUrl + "Token/arcgis";
      serverInfo.hasServer = true;
      esriId.registerServers([serverInfo]);
      // console.log(serverInfo.tokenServiceUrl);

      // RequestUtils.makeHttpQuery(serverInfo.tokenServiceUrl, "POST", "", true)
      new Promise((r) =>
        r({
          token: token,
        })
      )
        .then((tokenObj) => ((GetArcGISToken.token = tokenObj.token), tokenObj))
        .then(
          (tokenObj) => (
            esriId.registerToken({
              server: config.portalUrl + "/sharing/rest",
              ...tokenObj,
            }),
            esriId.registerToken({
              server: config.serverUrl + "/rest/services",
              ...tokenObj,
            })
          )
        )
        .then(() => (GetArcGISToken.tokenRegistered = true))
        .then(resolve)
        .catch(reject);
    });
  }

  static queryForToke() {
    return new Promise((resolve, reject) => {
      if (GetArcGISToken.tokenRegistered) {
        resolve();
        return;
      }

      try {
        GetArcGISToken.user = JSON.parse(sessionStorage.getItem("user")) || {
          displayName: "Guest",
        };
        if (
          Date.now() - (GetArcGISToken.user.timestamp || 0) >
          1000 * 60 * 60 * config.sessionTimeout
        )
          throw new Error();
      } catch {
        var err = new Error();
        err.cause = { httpCode: 403 };
        throw err;
      }

      let serverInfo = new ServerInfo();
      serverInfo.server = config.portalUrl;
      serverInfo.tokenServiceUrl = config.webSrvUrl + "Token/arcgis";
      serverInfo.hasServer = true;
      esriId.registerServers([serverInfo]);

      // RequestUtils.makeHttpQuery(serverInfo.tokenServiceUrl, "POST", "", true)
      new Promise((r) => r({ token: GetArcGISToken.user.arcGISToken }))
        .then((tokenObj) => ((GetArcGISToken.token = tokenObj.token), tokenObj))
        .then(
          (tokenObj) => (
            esriId.registerToken({
              server: config.portalUrl + "/sharing/rest",
              ...tokenObj,
            }),
            esriId.registerToken({
              server: config.serverUrl + "/rest/services",
              ...tokenObj,
            })
          )
        )
        .then(() => (GetArcGISToken.tokenRegistered = true))
        .then(resolve)
        .catch(reject);
    });
  }
}

export default GetArcGISToken;
